import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import { captureReferral } from "./lib/referral";
import { initConsentedAnalytics } from "./lib/analytics";
import ProtectedRoute from "./components/ProtectedRoute";
import MaintenanceGate from "./components/MaintenanceGate";
import MetaRouteTracker from "./components/MetaRouteTracker";
import ConsentBanner from "./components/ConsentBanner";
import ScrollToTop from "./components/ScrollToTop";

import Landing from "./pages/Landing";
import Register from "./pages/Register";
import Verify from "./pages/Verify";
import CertificateVerify from "./pages/CertificateVerify";
import Payment from "./pages/Payment";
import TeamSetup from "./pages/TeamSetup";
import TeamDashboard from "./pages/TeamDashboard";
import InviteAccept from "./pages/InviteAccept";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import SubmitRound1 from "./pages/SubmitRound1";
import SubmitRound2 from "./pages/SubmitRound2";
import JudgeDashboard from "./pages/JudgeDashboard";
import JudgeScore from "./pages/JudgeScore";
import Results from "./pages/Results";
import ResultsEdition from "./pages/ResultsEdition";
import Editions from "./pages/Editions";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RefundPolicy from "./pages/RefundPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import Profile from "./pages/Profile";

function App() {
  // Capture an ambassador ?ref= code on first load (persists 30 days).
  useEffect(() => { captureReferral(); initConsentedAnalytics(); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#111827", color: "#F9FAFB", border: "1px solid rgba(255,255,255,0.1)" } }} />
        <ScrollToTop />
        <MetaRouteTracker />
        <ConsentBanner />
        <MaintenanceGate>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/verify-certificate" element={<CertificateVerify />} />
          <Route path="/verify-certificate/:id" element={<CertificateVerify />} />
          <Route path="/payment" element={
            <ProtectedRoute>
              <Payment />
            </ProtectedRoute>
          } />
          <Route path="/team" element={
            <ProtectedRoute requirePaid>
              <TeamSetup />
            </ProtectedRoute>
          } />
          <Route path="/team/dashboard" element={
            <ProtectedRoute requirePaid>
              <TeamDashboard />
            </ProtectedRoute>
          } />
          <Route path="/invite" element={<InviteAccept />} />
          <Route path="/submit/round1" element={
            <ProtectedRoute requirePaid>
              <SubmitRound1 />
            </ProtectedRoute>
          } />
          <Route path="/submit/round2" element={
            <ProtectedRoute requirePaid>
              <SubmitRound2 />
            </ProtectedRoute>
          } />
          <Route path="/login" element={<Login />} />
          <Route path="/judge/login" element={<Navigate to="/login" replace />} />
          <Route path="/judge/dashboard" element={<JudgeDashboard />} />
          <Route path="/judge/score/:team_id" element={<JudgeScore />} />
          <Route path="/results" element={<Results />} />
          <Route path="/results/:slug" element={<ResultsEdition />} />
          <Route path="/editions" element={<Editions />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </MaintenanceGate>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

